import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, checkPermission } from 'utils';
import moment from 'moment';
import { NewsService } from 'services';
import { Input, DatePicker, Pagination, Modal, Tooltip } from 'components';
import { CleanIcon, AddIcon, ViewIcon, EditIcon, TrashIcon } from 'assets/icons';
import ModalCreate from './modal-create';
import ModalView from './modal-view';
import queryString from 'query-string';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	since: '',
	until: ''
}

class News extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null,
		visible_view: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Noticias',
				onBack: null
			}
		});

		this.load();

		if (this.props.location?.search) {
			const params = queryString.parse(this.props.location?.search);

			if (params.create) {
				this.setState({
					visible: true
				});
			}

			this.props.history.replace({
		        search: ''
		    });
		}
	}

	load = async (withoutLoading: boolean = false,callback = () => {}) => {
		const res: any = await NewsService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			since: this.state.form.since && moment(this.state.form.since).format('YYYY-MM-DD'),
			until: this.state.form.until && moment(this.state.form.until).format('YYYY-MM-DD'),
		});
		this.setState({
			data: res.news?.rows || [],
			last_page: res.news?.count || 1
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		},() => this.load(true));
	}

	view = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			visible_view: true,
			item
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	edit = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		this.setState({
			visible: true,
			visible_view: false,
			item
		});
	}

	delete = (e: any, item: any) => {
		if (e) {
			e.preventDefault();
		}
		Globals.confirm('¿Desea eliminar la noticia?',async () => {
			await NewsService.admin.delete({
				news_id: item.id
			});
			this.setState({
				visible_view: false,
				item: null
			});
			this.load(true);
		});
	}

	render() {
		const { visible, visible_view, data } = this.state;

		return (
			<div id="admin-news">
				<Modal
		          className="modal-create-news"
		          visible={ visible }
		          title={ (this.state.item ? 'Editar' : 'Nueva') + ' noticia' }
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreate
		            item={ this.state.item }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-news"
		          visible={ visible_view }
		          // @ts-ignore
		          title={ this.state.item?.title }
		          onClose={ () => this.onCloseView() }
		        >
		          <ModalView
		          	onEdit={ this.edit }
		          	onDelete={ this.delete }
		            item={ this.state.item }
		            onClose={ () => this.onCloseView() } />
		      	</Modal>

				<div className="row row-filter">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-11 row">
								<div className="col-md-6">
									<Input
										value={ this.state.form.search }
										name="search"
										placeholder="Buscar"
										label="Buscar por título"
										className="input-table"
										onSubmit={ () => this.load() }
										onChange={ (e: any) => {
											clearTimeout(this.timer);
											this.timer = setTimeout(() => {
												this.load(true);
											},1000);
											this.change(e); 
										} } />
								</div>
								<div className="col-md">
									<DatePicker
										label="Desde"
										placeholder="Desde"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'since'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.since }
									/>
								</div>
								<div className="col-md">
									<DatePicker
										label="Hasta"
										placeholder="Hasta"
										onChange={ (text: string) => {
											this.change({
												target: {
													value: text,
													name: 'until'
												}
											},() => this.load(true));
										} }
										value={ this.state.form.until }
									/>
								</div>
							</div>
							<div className="col-md-1">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
				</div>

				<div className="container-table">
					<div className="row">
						<div className="col-md-8">
							<h3>Noticias registradas</h3>
						</div>
						<div className="col-md-4 text-right">
							<button className="btn btn-add" onClick={ () => this.add() }>
								<img src={ AddIcon } />
								Nuevo
							</button>
						</div>
					</div>
					<hr />
					{
						data.map((item: any) => {
							return (
								<>
									<div className="item">
										{
											item?.image && (
												<div>
													<div className="container-image">
														<img className="image" src={ Constants.BASE_STORAGE + item?.image } />
													</div>
												</div>
											)
										}
										<div style={{ flex: 1, overflow: 'hidden', paddingRight: '10px' }}>
											<p className="name">{ item?.title }</p>
											<p className="date">{ moment(item?.created_at).format('DD/MM/YYYY') }</p>
										</div>
										<Tooltip title="Ver">
											<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,item) }>
												<img src={ ViewIcon } />
											</a>
										</Tooltip>
										{
											checkPermission(Constants.MODULES.NEWS,'delete') && (
												<Tooltip title="Editar">
													<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,item) }>
														<img src={ EditIcon } />
													</a>
												</Tooltip>
											)
										}
										{
											checkPermission(Constants.MODULES.NEWS,'delete') && (
												<Tooltip title="Editar">
													<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,item) }>
														<img src={ TrashIcon } />
													</a>
												</Tooltip>
											)
										}
									</div>
								</>
							)
						})
					}
					{
						data.length == 0 && (
							<p className="no-items">No se encontraron registros</p>
						)
					}
				</div>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(News);